import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BASEURL}/api`,
  withCredentials: true,
  headers: {
    "ngrok-skip-browser-warning": "567key",
  },
});
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const { status, data } = error.response;

      if (status === 441 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          await API.post("/auth/refresh-token");
          return API(originalRequest);
        } catch (refreshError) {
          console.error("Error refreshing token:", refreshError);
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }

      if ([440, 442, 443].includes(status)) {
        console.warn("Redirecting to login due to:", data.messageCode);
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default API;
